var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultLayout',[_c('div',[_c('ChainHero',{attrs:{"hero":_vm.hero}}),_vm._v(" "),_c('ChainPageContent',{attrs:{"chain":_vm.chain || {},"locations":_vm.locations || [],"per-page":_vm.PER_PAGE,"loading":_vm.loading},on:{"fetch-more":_vm.handleFetchMore}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }